import { Box, Grid } from "@gti-controls-v2/web-core";
import { ConsumosGrid } from "./components/ConsumosGrid";
import { ConsumosDesktopLeftPanel } from "./components/ConsumosDesktopLeftPanel";

export const ConsumosDesktop = (props) => {

  return (
    <>
      <Box sx={{ p: 2 }}>

        <Grid container spacing={2}>

          <Grid item xs={2} marginTop="14px">
            <ConsumosDesktopLeftPanel cortes={props.cortes} />
          </Grid>

          <Grid item xs={10}>
            <ConsumosGrid
              consumos={props.consumos}
              refreshConsumos={props.refreshConsumos}
              hacerCorte={props.hacerCorte}
              loading={props.loading} />
          </Grid>

        </Grid>

      </Box>
    </>
  );
};

export default ConsumosDesktop;
